export const smallHitSlop ={left:8,right:8,top:8,bottom:8}
export const bigHitSlop ={left:12,right:12,top:12,bottom:12}